module.exports = "../fonts/viber_enter.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/viber_enter.svg
// module id = 95
// module chunks = 0